import { CssBaseline } from "@mui/material";
import Container from "@mui/material/Container";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import HomePage from "./pages/home/HomePage";
import Products from "./pages/productsPage/Products";
import FetchProduct from "./pages/fetchProductPage/FetchProduct";
import Footer from "./components/footer/Footer";
import Navbar from "./components/navbar/Navbar";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import AOS from "aos";
import "aos/dist/aos.css";
import NotFound from "./components/notFound/NotFound";
import ToTopButton from "./components/Button/ToTopButton";

AOS.init();

function App() {
  return (
    <>
      <CssBaseline />
      <Container
        maxWidth="xl"
        style={{
          width: "100%",
          margin: "0 auto",
          padding: "0",
        }}
      >
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/category/:categoryId" element={<Products />} />
          <Route
            path="/category/product/:productId"
            element={<FetchProduct />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <ToTopButton />
        <Toaster containerStyle={{ zIndex: "100000" }} />
      </Container>
    </>
  );
}

export default App;
